import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = ({ className = "", testId, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input data-testid={testId} type={show ? "text" : "password"} className={`pr-11 ${className}`} {...props} />
      <button type="button" data-testid={`${testId}-toggle`} onClick={() => setShow((s) => !s)} tabIndex={-1}
        aria-label={show ? "Ocultar senha" : "Mostrar senha"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-white transition-colors">
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default PasswordInput;
